import styled, { css } from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const BarChartStyle = styled.div`
  /* Parent styles
  ------------------------------- */

  width: 100%;
  margin: 0px 20px 10px 20px;
  display: flex;
  flex-grow: 1;
  .chart-wrapper {
    display: flex;
    flex-direction: column;
    width: fit-content;
    margin: 0 auto;
  }
  .tooltip-container {
    position: relative;
    width: 100%;
    height: 0px;
  }
  .tool-tip {
    display: none;
    white-space: nowrap;
    color: white;
    background-color: gray;
    position: absolute;
    width: fit-content;
    padding: 5px 10px;
    border-radius: 6px;
    top: 20px;
    transform: translate(-50%, -50%);
    ::before {
      content: '';
      position: absolute;
      background-color: gray;
      width: 10px;
      height: 10px;
      top: 0px;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
  .distribution {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid ${VARIABLES.COLORS.GRAY_2};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    color: ${VARIABLES.COLORS.BLUE_1};

    .title {
      font-size: 1.5em;
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
      padding: 10px 0px 10px 20px;
      border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_2};
    }
    .chart {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 37.5em;
    }

    .footer {
      font-size: 1em;
      padding: 20px 0px 20px 0px;
      border-top: 1px solid ${VARIABLES.COLORS.GRAY_2};
      display: flex;
      justify-content: center;
      align-items: center;
      .full-score {
        margin-right: 10px;
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
      }
      .high-risk {
        margin: 0 10px 0 10px;
        display: flex;
        .box-red {
          margin: auto 8px auto 0;
          background-color: #e24132;
          width: 18px;
          height: 18px;
        }
      }
      .medium-risk {
        margin: 0 10px 0 10px;
        display: flex;
        .box-yellow {
          margin: auto 8px auto 0;
          background-color: #ffb60f;
          width: 18px;
          height: 18px;
        }
      }
      .low-risk {
        margin: 0 10px 0 10px;
        display: flex;
        .box-green {
          margin: auto 8px auto 0;
          background-color: #16a651;
          width: 18px;
          height: 18px;
        }
      }
    }
  }
  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
  }

  @media all and (max-width: 1280.98px) {
  }

  @media all and (max-width: 1024.98px) {
  }
`
